export type GearSpecAttribute = { key: string; label: string }
export type ProductLike = { attributes?: Record<string, unknown> }

const attributeList: GearSpecAttribute[] = [
  { key: 'manufacturer', label: 'Brand' },
  { key: 'color', label: 'Color' },
  { key: 'rogue_show_sku', label: 'SKU' },
  { key: 'bar_type', label: 'Bar Type' },
  { key: 'bar_warranty', label: 'Warranty' },
  { key: 'made_in_usa', label: 'Made In USA' },
  { key: 'rogue_assembled_usa', label: 'Assembled In USA' },
  { key: 'bumper_plate', label: 'Bumper Plate Type' },
  { key: 'kettlebell_type', label: 'KB Setup' },
  { key: 'collars', label: 'Collars' },
  { key: 'slam_ball', label: 'Slam Balls' },
  { key: 'climbing_rope', label: 'Climbing Rope' },
  { key: 'rings', label: 'Rings' },
  { key: 'dynamax', label: 'Rogue Medball' },
  { key: 'plyobox', label: 'Plyobox' },
  { key: 'squat_stand', label: 'Squat Stand' },
  { key: 'ghd', label: 'GHD' },
  { key: 'pullup_rig', label: 'Pullup Rig' },
  { key: 'jump_rope', label: 'Jump Rope' },
  { key: 'abmat', label: 'Abmat' },
  { key: 'rower', label: 'Timer' },
  { key: 'bumpers', label: 'Bumpers' },
  { key: 'bars', label: 'Bars' },
  { key: 'rowers', label: 'Rowers' },
  { key: 'strap_colors', label: 'Strap Colors' },
  { key: 'bumper_width_5kg', label: '5KG Plate Width' },
  { key: 'bumper_width_10kg', label: '10KG Plate Width' },
  { key: 'bumper_width_15kg', label: '15KG Plate Width' },
  { key: 'bumper_width_20kg', label: '20KG Plate Width' },
  { key: 'bumper_width_25kg', label: '25KG Plate Width' },
  { key: 'bumper_width_2_5lb', label: '2.5LB Plate Width' },
  { key: 'bumper_width_5lb', label: '5LB Plate Width' },
  { key: 'bumper_width_10lb', label: '10LB Plate Width' },
  { key: 'bumper_width_15lb', label: '15LB Plate Width' },
  { key: 'bumper_width_25lb', label: '25LB Plate Width' },
  { key: 'bumper_width_35lb', label: '35LB Plate Width' },
  { key: 'bumper_width_45lb', label: '45LB Plate Width' },
  { key: 'bumper_width_55lb', label: '55LB Plate Width' },
  { key: 'shipping_price_new', label: 'Shipping Price New' },
  { key: 'skins_size', label: 'Skins Size' },
  { key: 'parallettes', label: 'Parallettes' },
  { key: 'shoes', label: 'Shoes' },
  { key: 'dumbbell', label: 'Dumbbells' },
  { key: 'banner_size', label: 'Banner Size' },
  { key: 'specialty', label: 'Sport Specialty' },
  { key: 'regu_type', label: 'Type' },
  { key: 'regu_color', label: 'Colors' },
  { key: 'regu_sqft', label: 'Square Feet' },
  { key: 'additional_text', label: 'Additional Info' },
  { key: 'adlinfo_weight', label: 'Product Weight' },
  { key: 'adlinfo_length', label: 'Length' },
  { key: 'adlinfo_width', label: 'Width' },
  { key: 'adlinfo_height', label: 'Height' },
  { key: 'adlinfo_diameter', label: 'Diameter' },
  { key: 'thickness', label: 'Thickness' },
  { key: 'adlinfo_footprint', label: 'Foot Print' },
  { key: 'adlinfo_material', label: 'Material Type' },
  { key: 'adlinfo_steel', label: 'Steel Notes' },
  { key: 'adlinfo_upholstery', label: 'Upholstery' },
  { key: 'adlinfo_foam', label: 'Foam Type' },
  { key: 'adlinfo_details', label: 'Other Product Specs' },
  { key: 'reebok_shoe_colors', label: 'Shoe Color' },
  { key: 'platform_type', label: 'Platforms' },
  { key: 'jumprope_handle_length', label: 'Handle Length' },
  { key: 'jumprope_handle_diameter', label: 'Handle Diameter' },
  { key: 'jumprope_cable_length', label: 'Cable Length' },
  { key: 'jumprope_cable_diameter', label: 'Cable Diameter' },
  { key: 'jumprope_cable_type', label: 'Cable Type' },
  { key: 'jumprope_cable_weight', label: 'Cable Weight' },
  { key: 'jumprope_construction', label: 'Handle Mechanism' },
  { key: 'bumper_diameter', label: 'Diameter' },
  { key: 'book_isbn', label: 'ISBN-13' },
  { key: 'book_publish_date', label: 'Publication Date' },
  { key: 'book_pages', label: 'Pages' },
  { key: 'book_cover', label: 'Cover Type' },
  { key: 'lens_color', label: 'Lens Color' },
  { key: 'frame_type', label: 'Frame' },
  { key: 'frame_color', label: 'Frame Color' },
  { key: 'tie_length', label: 'Tie Length' },
  { key: 'tie_color', label: 'Tie Color' },
  { key: 'tie_width', label: 'Tie Width' },
  { key: 'shoe_heel_height', label: 'Effective Heel Height' },
  { key: 'compatibility_infinity2', label: 'Infinity Compatible' },
  { key: 'compatibility_monster2', label: 'Monster Compatible' },
  { key: 'sleeve_thickness', label: 'Sleeve Thickness' },
  { key: 'servings', label: 'Servings' },
  { key: 'size_nutrition', label: 'Size' },
  { key: 'durometer_bumpers', label: 'Durometer' },
  { key: 'bar_loadable_length', label: 'Loadable Sleeve Length' },
  { key: 'bar_length', label: 'Bar Length' },
  { key: 'bar_distbtwnsleeve', label: 'Distance Between Sleeves' },
  { key: 'bar_diameter2', label: 'Diameter' },
  { key: 'inseam_length', label: 'Inseam Length' },
  { key: 'rogue_category_top_tab', label: 'Top Tab Content' },
  { key: 'care_info', label: 'Care Instructions' },
  { key: 'rogue_warranty_link', label: 'Warranty' },
  { key: 'inov_shoe_colors', label: 'Color' },
  { key: 'f_rating', label: 'F Rating™' },
  { key: 'bumper_collar_opening', label: 'Collar Opening' },
  { key: 'shirt_type', label: 'T-Shirts' },
  { key: 'shirt_size', label: 'General/Shirt Size' },
  { key: 'shoe_type', label: 'Shoe Type' },
  { key: 'shoe_size', label: 'Shoe Size' },
  { key: 'bar_kind', label: 'Bar Type' },
  { key: 'short_type', label: 'Shorts & Sweatpants' },
  { key: 'bar_use', label: 'Bar Use' },
  { key: 'bushing_bearing', label: 'Bushing/Bearing' },
  { key: 'bar_weight', label: 'Bar Weight' },
  { key: 'bar_knurl', label: 'Knurl' },
  { key: 'bar_center_knurl2', label: 'Center Knurl' },
  { key: 'bar_knurl_mark', label: 'Knurl Mark' },
  { key: 'bar_shaft_coating', label: 'Shaft Coating' },
  { key: 'bar_sleeve_coating', label: 'Sleeve Coating' },
  { key: 'bar_tensile_strength', label: 'Tensile Strength' },
  { key: 'bumper_type', label: 'Plate Type' },
  { key: 'plate_type', label: 'Metal Plates' },
  { key: 'storage_type', label: 'Storage' },
  { key: 'compression_gear_type', label: 'Compression & Protective Gear' },
  { key: 'sock_type', label: 'Socks' },
  { key: 'watch_type', label: 'Watches' },
  { key: 'accessory_type', label: 'Accessories' },
  { key: 'goruck_type', label: 'Ruck Type' },
  { key: 'goruck_volume', label: 'Bag Volume' },
  { key: 'compatibility_echo2', label: 'Echo Compatible' },
  { key: 'compatibility_mlite2', label: 'Monster Lite Compatible' },
  { key: 'books_and_media', label: 'Books & Media' },
  { key: 'flooring_length', label: 'Flooring Length' },
  { key: 'flooring_width', label: 'Flooring Width' },
  { key: 'max_user_weight', label: 'Max User Weight' },
  { key: 'seat_type', label: 'Seat Type' },
  { key: 'replacement_part_number', label: 'Replacement Part Number' },
  { key: 'h_5_compatible', label: 'H-5 Handle Compatible' },
]

export default function getGearSpecAttributes(product: ProductLike): GearSpecAttribute[] {
  return attributeList.filter((attr) => {
    const val = (product.attributes || ({} as Record<string, unknown>))[attr.key]
    
    return !!val && String(val).toLowerCase() !== 'n/a'
  })
}


